import moment from "moment";
import React from "react";
import { Table } from "reactstrap";
import useDocumentDownloader from "../../../../helpers/Common/useDocumentDownloader";
import { getParsedJson } from "../../../../helpers/common";
import styles from "./styles.module.css";
import { Link } from "react-router-dom";
import  { useState } from "react";
import { Spinner } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

const DebitsListing = ({ debitList }) => {
  // Tracking states for active rows during network transfer
  const [downloadingId, setDownloadingId] = useState(null);

  if (!debitList?.length) {
    return <h5 className="text-center mt-4">No history found.</h5>;
  }

  const getDetailPageUrl = (item) => {
    return `/candidate/details/${item?.candidateId}`;
  };

  /**
   * Directly triggers a native browser download for the specific candidate's resume
   */
  const handleDownloadResume = async (candidateId, candidateName) => {
    if (!candidateId) return;

    try {
      setDownloadingId(candidateId);
      
      const token = localStorage.getItem("webvi_authToken");
      const targetUrl = `https://sdsjobseekers.runasp.net/api/Candidate/${candidateId}/download-resume`;

      // Make the API request expecting a binary file back (blob)
      const response = await axios.get(targetUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // CRITICAL for handling file downloads cleanly
      });

      // Construct a clean, human-readable file name
      const cleanName = candidateName ? candidateName.replace(/\s+/g, "_") : `Candidate_${candidateId}`;
      let fileName = `${cleanName}_Resume.pdf`;

      // Optional: attempt to parse real file extension if sent via the content-disposition header
      const disposition = response.headers["content-disposition"];
      if (disposition && disposition.includes("filename=")) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, "");
        }
      }

      // Turn binary blob payload into a physical temporary URL string link
      const blob = new Blob([response.data], { type: response.headers["content-type"] || "application/pdf" });
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Programmatically click a hidden virtual anchor link element to run the download action
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      
      // Clean up memory leaks 
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      console.error("Resume download failure:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "No Resume Found.",
      });
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <Table bordered hover responsive striped>
      <thead>
        <tr>
          <th>#</th>
          <th>Candidate Name</th>
          <th>Candidate Email</th>
          <th>Candidate Contact No.</th>
          <th>Candidate Resume</th>
          <th>View Date</th>
          <th>Credit Used</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>
        {debitList.map((item, index) => (
          <tr key={item.viewId || index}>
            <th scope="row">{index + 1}</th>

            <td>{item.name || "-"}</td>

            <td>{item.email || "-"}</td>

            <td>{item.phoneNumber || "-"}</td>

            <td>
              <button
                className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                disabled={downloadingId === item.candidateId}
                onClick={() => handleDownloadResume(item.candidateId, item.name)}
              >
                {downloadingId === item.candidateId ? (
                  <>
                    <Spinner size="sm" className="me-1" /> Downloading...
                  </>
                ) : (
                  <>
                    <i className="uil uil-import"></i> Download
                  </>
                )}
              </button>
            </td>

            <td>
              {item.viewedAt
                ? moment(item.viewedAt).format("DD/MM/YYYY")
                : "-"}
            </td>

            <td>{item.creditsUsed}</td>

            <td>
              <Link
                to={getDetailPageUrl(item)}
                style={{ fontSize: 14 }}
              >
                View Details
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};


export default DebitsListing;
